/**
 * 汎用タブ切替関数（初期化時にインデックス0をアクティブにし、クリック時に切り替え）
 * rootEl: セクションのルート要素 (HTMLElement)
 *
 * 前提:
 *   ・タブ要素 = rootEl.querySelectorAll('.tab')
 *   ・パネル要素 = rootEl.querySelectorAll('.tab-content')
 *   ・タブ／パネルともに data-tab="0,1,2…" のように同じ値を付与
 *   ・“active” クラスでアクティブ表示を制御
 */
function initializeTabs(rootEl) {
  if (!rootEl) return;

  var tabs = rootEl.querySelectorAll('.tab');
  var panes = rootEl.querySelectorAll('.tab-content');
  if (!tabs.length || !panes.length) return;

  // 初期状態：インデックス0だけ active に、対応パネル以外は display:none
  var firstKey = tabs[0].dataset.tab;
  tabs.forEach(function (tab, i) {
    tab.classList.toggle('active', i === 0);
  });
  panes.forEach(function (pane) {
    pane.style.display = pane.dataset.tab === firstKey ? '' : 'none';
  });

  // クリック時に active 切替 + content の表示切替
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function (e) {
      e.preventDefault();
      var key = tab.dataset.tab;

      tabs.forEach(function (t) {
        t.classList.remove('active');
      });
      tab.classList.add('active');

      panes.forEach(function (pane) {
        pane.style.display = pane.dataset.tab === key ? '' : 'none';
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  // ── タブ切替を持つすべてのセクションを初期化 ──
  var tabSelectors = [
    '.top-cordinate-section',
    '.top-ranking-section',
    '.top-item-search-section',
  ].join(', ');
  document.querySelectorAll(tabSelectors).forEach(function (section) {
    initializeTabs(section);
  });

  /**
   * Splideスライダー
   */
  if (typeof Splide === 'undefined') return;

  // ── 1) ページ読み込み時に “data-splide-options” を持つ .splide をマウント ──
  document
    .querySelectorAll('.splide[data-splide-options]')
    .forEach(function (el) {
      // 既にインスタンスがあれば破棄
      if (el.splide) {
        el.splide.destroy();
      }

      // data-splide-options を JSON.parse
      var optionsJson = el.getAttribute('data-splide-options') || '{}';
      var opts;
      try {
        opts = JSON.parse(optionsJson);
      } catch (e) {
        console.warn('Invalid JSON in data-splide-options:', optionsJson);
        opts = {};
      }

      // Splide を mount
      var splideInstance = new Splide(el, opts);
      splideInstance.mount();

      // インスタンスを要素に保持しておく
      el.splide = splideInstance;
    });

  // ── 2) “splide:reinit” カスタムイベントをリッスンして再初期化 ──
  document.addEventListener('splide:reinit', function (evt) {
    var el = evt.detail.element;
    if (!el || !el.classList.contains('splide')) return;

    // 既存インスタンスを破棄
    if (el.splide) {
      el.splide.destroy();
    }

    // オプションを再度 JSON.parse
    var optionsJson = el.getAttribute('data-splide-options') || '{}';
    var opts;
    try {
      opts = JSON.parse(optionsJson);
    } catch (e) {
      console.warn(
        'Invalid JSON in data-splide-options (reinit):',
        optionsJson
      );
      opts = {};
    }

    // 再度 Splide を mount
    var splideInstance = new Splide(el, opts);
    splideInstance.mount();
    el.splide = splideInstance;
  });
});
